import _ from 'lodash';
import React, { PropTypes } from 'react';

const Input = (props) => {
    const { activeId, mode, widget, actions } = props;

    const onInputChange = (e) => {
        actions.setInputWidgetValue(widget.id, e.target.value);

        if (mode === 'CLIENT') {
            if (_.isEmpty(e.target.value)) {
                actions.deleteResult(activeId);
            } else {
                actions.saveResult(activeId, widget.type, e.target.value);
            }
        }
    };

    return (
        <div>
            { (mode === 'CLIENT') ?
                <input type="text" name={`date-widget-${widget.id}`} onChange={onInputChange} defaultValue={widget.value} placeholder={widget.placeholder} /> :
                <input type="text" disabled name={`date-widget-${widget.id}`} onChange={onInputChange} defaultValue={widget.value} placeholder={widget.placeholder} /> }
        </div>
    );
};

Input.propTypes = {
    activeId: PropTypes.number.isRequired,
    widget: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
};

export default Input;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/Input/Input.jsx